import _JSXStyle from "styled-jsx/style";
import { useConfig } from '@dhis2/app-runtime';
import PropTypes from 'prop-types';
import React from 'react';
import { joinPath } from './join-path.js';
import i18n from './locales/index.js';
import { NotificationIcon } from './notification-icon.js';
const hasAuthority = (userAuthorities, authId) => Array.isArray(userAuthorities) && userAuthorities.some(userAuthId => userAuthId === 'ALL' || userAuthId === authId);
export const Notifications = _ref => {
  let {
    interpretations,
    messages,
    userAuthorities
  } = _ref;
  const {
    baseUrl
  } = useConfig();
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-notifications",
    className: "jsx-55705730"
  }, hasAuthority(userAuthorities, 'M_dhis-web-interpretation') && /*#__PURE__*/React.createElement(NotificationIcon, {
    count: interpretations,
    href: joinPath(baseUrl, 'dhis-web-interpretation'),
    kind: "message",
    dataTestId: "headerbar-interpretations",
    title: i18n.t('Interpretations'),
    "aria-label": i18n.t('Interpretations')
  }), hasAuthority(userAuthorities, 'M_dhis-web-messaging') && /*#__PURE__*/React.createElement(NotificationIcon, {
    message: "email",
    count: messages,
    href: joinPath(baseUrl, 'dhis-web-messaging'),
    kind: "interpretation",
    dataTestId: "headerbar-messages",
    title: i18n.t('Messages'),
    "aria-label": i18n.t('Messages')
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "55705730"
  }, ["div.jsx-55705730{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%;}"]));
};
Notifications.propTypes = {
  interpretations: PropTypes.number,
  messages: PropTypes.number,
  userAuthorities: PropTypes.arrayOf(PropTypes.string)
};